export default {
  "common.brand": "USFanslink",
  "nav.home": "Inicio",
  "nav.spreadsheet": "Spreadsheet",
  "nav.creators": "Creadores",
  "nav.reviews": "Reseñas",
  "nav.shipping": "Envíos",
  "nav.coupons": "Cupones",
  "nav.guides": "Guías",
  "nav.shoppingGuide": "Guía de compras",

  "hero.badge": "Recursos actualizados · Información organizada",
  "hero.title": "USFans Spreadsheet – Explora creadores, reseñas y recursos",
  "hero.subtitle": "Encuentra información útil de USFans en un solo centro de recursos organizado. Explora el USFans Spreadsheet, el directorio de creadores, reseñas, guías de envío, cupones, información de almacén y las últimas novedades.",
  "hero.ctaSpreadsheet": "usfans spreadsheet",
  "hero.ctaBuyNow": "buy it now",
  "hero.dropdownLabel": "Ir a una categoría",
  "hero.dropdownPlaceholder": "Selecciona una categoría…",
  "hero.trust": "Recursos actualizados • Información organizada • Enfoque en seguridad • Fácil de explorar",

  "categories.title": "Explora las categorías populares",
  "categories.subtitle": "Salta directamente a los productos que buscas en la tienda del USFans spreadsheet.",

  "categories.shoes": "Zapatos",
  "categories.hoodies": "Sudaderas",
  "categories.tshirts": "Camisetas",
  "categories.jackets": "Chaquetas",
  "categories.pants": "Pantalones/Shorts",
  "categories.headwear": "Gorros",
  "categories.sets": "Conjuntos",
  "categories.underwear": "Ropa interior",
  "categories.jersey": "Camisetas deportivas",
  "categories.accessories": "Accesorios",
  "categories.bags": "Bolsos",
  "categories.belts": "Cinturones",
  "categories.perfumes": "Perfumes",
  "categories.other": "Otros artículos",

  "content.eyebrow": "Centro del USFans Spreadsheet",
  "content.title": "¿Qué es el USFans Spreadsheet?",
  "content.p1": "El USFans Spreadsheet es un recurso único y organizado que reúne la información relacionada con USFans en un solo lugar. En lugar de buscar en muchas páginas distintas, los visitantes pueden encontrar creadores, reseñas, detalles de envío, cupones y guías de almacén reunidos en una estructura clara y fácil de consultar.",
  "content.p2": "El corazón de este centro es el directorio de creadores. Cada creador aparece con su categoría, la información disponible y el estado de su última actualización, para que puedas entender rápidamente quién está activo y qué tipo de contenido ofrece.",
  "content.sub1": "Cómo usar el spreadsheet",
  "content.p3": "Empieza eligiendo una categoría en el menú desplegable de arriba. Cada categoría enlaza con una sección específica de la tienda principal, así puedes ir directamente a los productos que te interesan — ya sean zapatos, camisetas deportivas, accesorios o cualquier otra cosa del catálogo.",
  "content.sub2": "Reseñas, envíos y cupones",
  "content.p4": "Más allá del directorio, el centro también organiza guías prácticas. Puedes leer reseñas para entender la plataforma, consultar los costes de envío antes de comprar y buscar información actual sobre cupones y descuentos. Todo está reunido para que no tengas que buscarlo por tu cuenta.",
  "content.sub3": "Seguridad y transparencia",
  "content.p5": "Este sitio es un centro de recursos independiente y no es la web oficial de USFans. Nos centramos en mantener la información organizada y fácil de verificar, para que puedas explorar con confianza y seguir los enlaces a la tienda principal cuando quieras navegar.",

  "article.ctaTitle": "¿Quieres ver el panorama completo?",
  "article.ctaText": "Lee nuestra guía completa del USFans Spreadsheet para conocer a fondo el directorio de creadores, reseñas, envíos y más.",
  "article.ctaButton": "Leer la guía completa",

  "articles.title": "Guías y artículos destacados de USFans",
  "articles.subtitle": "Guías independientes y detalladas sobre reseñas, envíos, cupones, almacén, seguridad y más.",
  "articles.readMore": "Leer guía",

  "footer.tagline": "Un centro de recursos independiente para la información del USFans Spreadsheet.",
  "footer.navTitle": "Explora",
  "footer.categoriesTitle": "Categorías",
  "footer.disclaimer": "USFanslink es un centro de recursos independiente y no está afiliado con la web oficial de USFans.",
  "footer.rights": "Todos los derechos reservados."
};